'use client'

import { useMemo } from 'react'
import { MdOutlineMap } from 'react-icons/md'


import { mxData } from '../utils/constants'
import { useAutocompleteStore } from '../store'
import { ZoneCoincidence } from '../interfaces/zoneInterface'
import { SuggestionOriginEnum } from '../interfaces/autocomplete'
import { GoogleMapsStructuredPlace } from '../interfaces/googleMapsInterfaces'
import { ESearchLevel } from '../enums'
import { composeClasses } from '@wiggot/utils/src/strings'

interface Props {
  coincidence: ZoneCoincidence
  className?: string
  itemTextClassName?: string
  index: number
  selectedIndex: number
  withRemarkSelected?: boolean
  focusOptionClassNames?: string
  searchText?: string
  remarkSelectedClassNames?: string
  onSelected: (place: GoogleMapsStructuredPlace) => void
}

const ZoneOption = ({
  coincidence,
  className = '',
  itemTextClassName,
  index,
  selectedIndex,
  withRemarkSelected,
  remarkSelectedClassNames,
  focusOptionClassNames,
  searchText,
  onSelected
}: Props): JSX.Element => {
  const {
    setSelectedSuggestionOrigin
  } = useAutocompleteStore()

  const select = async (): Promise<void> => {
    const {
      properties: { zoneName, stateName, zoneId, latitude, longitude }
    } = coincidence


    setSelectedSuggestionOrigin(SuggestionOriginEnum.MONOPOLIO)

    onSelected({
      fullAddress: coincidenceName,
      zoneId,
      searchLevel: ESearchLevel.NEIGHBORHOOD,
      coordinates: {
        latitude,
        longitude
      },

      placeId: '',
      streetNumber: '',
      street: '',
      neighborhood: '',
      town: '',
      location: stateName ?? '',
      postalCode: '',
      navigation: {
        state: mxData.name,
        municipality: stateName,
        neighborhood: zoneName,
        property: ''
      }
    })
  }

  const coincidenceName = useMemo(() => {
    const zoneName = coincidence?.properties?.zoneName ?? ''
    const locationName = coincidence?.properties?.stateName ?? ''
    return `${zoneName}, ${locationName}`
  }, [coincidence])

  const isSelected = useMemo(() => {
    const textInInput = searchText?.replace(/ /g, '').toLowerCase()
    const textInSuggestion = coincidenceName?.replace(/ /g, '').toLowerCase()
    return textInInput === textInSuggestion
  }, [searchText, coincidenceName])

  return (
    <button
      type="button"
      onClick={select}
      className={composeClasses(
        'w-full flex justify-start text-left items-center gap-x-[10px] py-[5px] hover:bg-gray-100 text-text-primary',
        index === selectedIndex && (focusOptionClassNames || 'bg-gray-100'),
        isSelected &&
          withRemarkSelected &&
          (remarkSelectedClassNames || '!text-button-primary !bg-bg-blue-02'),
        className
      )}
    >
      <MdOutlineMap className="w-[18px] h-[18px]  !flex justify-center items-center flex-grow-0 flex-shrink-0 basis-auto" />

      <p className={composeClasses('text-xs truncate', itemTextClassName)}>
        {coincidenceName}
      </p>
    </button>
  )
}

export default ZoneOption
